type UsuarioDisplaySource = {
  nome?: string | null;
  nome_resumido?: string | null;
} | null | undefined;

/** Nome de exibição do usuário: prioriza nome_resumido, depois nome. */
export function getUsuarioDisplayName(usuario: UsuarioDisplaySource): string {
  if (!usuario) return '';

  const resumido = typeof usuario.nome_resumido === 'string' ? usuario.nome_resumido.trim() : '';
  if (resumido) return resumido;

  return typeof usuario.nome === 'string' ? usuario.nome.trim() : '';
}

type MensagemRemetenteSource = {
  de_mim: boolean;
  usuario_id?: number | null;
  usuario?: UsuarioDisplaySource & { id?: number };
};

/** Rótulo do remetente exibido acima da bolha de mensagem no chat. */
export function getMensagemRemetenteLabel(
  msg: MensagemRemetenteSource,
  contatoNome: string,
  currentUserId?: number | null,
  usuariosPorId?: Map<number, UsuarioDisplaySource>,
): string {
  if (!msg.de_mim) {
    return contatoNome;
  }

  if (currentUserId && msg.usuario_id === currentUserId) {
    return 'Você';
  }

  const usuarioSource = msg.usuario
    || (msg.usuario_id ? usuariosPorId?.get(msg.usuario_id) : undefined);

  const nomeUsuario = getUsuarioDisplayName(usuarioSource);
  if (nomeUsuario) return nomeUsuario;

  if (msg.usuario_id) return 'Atendente';
  return 'Atendimento';
}
